module.exports = __webpack_public_path__ + "static/img/P4_gray.9b7b998.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/P4_gray.png
// module id = 24xM
// module chunks = 0